<template>
  <el-popover v-if="shareInfo.pid" placement="top-end" width="450" v-model="dialogVisibleShare">
    <el-form size="mini" ref="formShare" :rules="rulesShare" :model="formShare" label-width="80px">
      <div style="text-align: right; margin-bottom: 5px; cursor: pointer">
        <i class="el-icon-close" @click="dialogVisibleShare = false"></i>
      </div>
      <el-form-item label="分享给" prop="share_users">
        <div style="display: flex">
          <el-select style="width: 100%" v-model="formShare.share_users" multiple filterable default-first-option
            placeholder="请填写要分享的人员邮箱">
            <el-option v-for="(key,value) in allSelect.TEXTUSERS" :key="key" :label="key + '（' + value + ')'"
              :value="value">
            </el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" content="分享到企业微信" placement="left">
            <el-button style="margin-left: 5px; width: 62px" :disabled="shareLoading" type="primary" @click="onSubmit()"
              onload="shareLoading">分享</el-button>
          </el-tooltip>
        </div>
      </el-form-item>
      <el-form-item label="链接" prop="url">
        <div style="display: flex">
          <el-input v-model="formShare.url" readonly></el-input>
          <el-button type="success" style="margin-left: 5px; width: 62px" v-clipboard:copy="formShare.url"
            v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</el-button>
        </div>
      </el-form-item>
    </el-form>
    <div slot="reference" class="share_icon">
      <i class="el-icon-share"></i>
    </div>
  </el-popover>
</template>
<script>
import {
  postDevOpsSpaceProducerShareApi,
} from "@/server/tops/devOps";
import { mapState } from "vuex";
export default {
  props: {
    shareInfo: {
      type: Object,
      default: () => {
        return {
          pid: '',
          tid: '',
          type: '',
          tabid: '',
        };
      },
    },
  },
  data() {
    return {
      formShare: {
        share_users: [],
        url: ""
      },
      rulesShare: {
        share_users: [
          {
            required: true,
            message: "请填写要分享的人员邮箱",
            trigger: "blur",
          },
        ],
      },
      shareLoading: false,
      dialogVisibleShare: false,
    }
  },
  computed: {
    ...mapState(
      {
        allSelect: (state) => state.devOps.ALLSELECT,
      }
    )
  },
  created() {
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const { pid = '', tid = '', type = '', tabid = '' } = this.shareInfo;
    if (type === 'demand') {
      // this.formShare.url = `${window.location.origin}/devops/space/producer?route=devOpsDemandSpace?username=${username}&pid=${pid}&tabid=3`
      this.formShare.url = `${window.location.origin}/Home/devOpsDemandSpace/demand?&pid=${pid}`
      return;
    }
    if (type === 'task') {
      // this.formShare.url = `${window.location.origin}/devops/space/producer?route=devOpsProducerSpace?username=${username}&pid=${pid}&tid=${tid}&tabid=${tabid}`
      this.formShare.url = `${window.location.origin}/Home/devOpsTaskSpace/allTask?pid=${pid}&tid=${tid}`

      return;
    }
  },
  methods: {
    onCopySuccess: function (e) {
      this.$notify({
        message: "复制成功",
        type: "success",
      });
      this.dialogVisibleShare = false;
    },
    onCopyError: function (e) {
      this.$notify({
        message: "复制失败",
        type: "error",
      });
      this.dialogVisibleShare = false;
    },
    onSubmit: function () {
      this.$refs["formShare"].validate(async (valid) => {
        if (valid) {
          this.shareLoading = true;
          try {
            const { share_users = [] } = this.formShare;
            const { pid = '', tid = '' } = this.shareInfo;
            const param = {
              pid,
              tid,
              share_users: share_users.toString(),
            };
            const ret = await postDevOpsSpaceProducerShareApi(param);
            this.submitStatus = ret?.status === "success" ? "success" : "error";
            if (ret?.status === "success") {
              this.$notify({
                message: "分享成功",
                type: "success",
              });
            } else {
              this.$notify({
                message: error || "分享失败",
                type: "error",
              });
            }
          } catch (error) {
            this.$notify({
              message: error || "分享失败",
              type: "error",
            });
          } finally {
            this.dialogVisibleShare = false;
            this.shareLoading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
}
</script>
<style scoped>
.share_icon {
  cursor: pointer;
  position: absolute;
  right: 50px;
  top: 18px;
}
</style>
